var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataFormat.length !== 0)?_c('span',{staticClass:"fileLanguages d-block mb-1"},_vm._l((_vm.dataFormat),function(flag){return _c('flag',{key:flag,attrs:{"squared":false,"iso":_vm.fileIcon(flag)}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }